import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router';
import { Routes } from '@/Routes.constants.ts';

import React from 'react';
import { NavigationAppBar } from './Components/NavigationAppBar';
import { DetailPageTitle } from '../DetailsPage/DetailsPageTitle';
import { TablePageTitle } from '../TablePage/TablePageTitle';

type RoutingParams = {
  iccid?: string;
  euicc?: string;
};

type DetailsTitleProps = { route: Routes; basePageTitle: string };

const SimDetailsTitle: React.FC<DetailsTitleProps> = ({ route, basePageTitle }) => {
  const { t } = useTranslation();
  const { iccid } = useParams<RoutingParams>();

  return (
    <DetailPageTitle
      title={`${t('simInventory.sim')} ${iccid}`}
      rootLocation={{
        to: route,
        name: basePageTitle,
      }}
      currentLocationName={t('simInventory.SIMDetails')}
    />
  );
};

const RSimInventoryDetailsTitle = () => {
  const { t } = useTranslation();
  const { euicc } = useParams<RoutingParams>();

  return (
    <DetailPageTitle
      title={`${t('rSimInventory.title')} ${euicc}`}
      rootLocation={{
        to: Routes.productsRsim,
        name: t('rSimInventory.rsimProducts'),
      }}
      currentLocationName={t('rSimInventory.rSIMDetails')}
    />
  );
};

type AppNavigationProps = {
  title?: React.ReactNode;
};

export const AppNavigation = ({ title }: AppNavigationProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const { iccid, euicc } = useParams<RoutingParams>();

  const getTitle = () => {
    if (location.pathname.includes(Routes.simInventory) && iccid) {
      return (
        <SimDetailsTitle route={Routes.simInventory} basePageTitle={t('simProfiles.simProfiles')} />
      );
    }

    if (location.pathname.includes(Routes.productsSim) && iccid) {
      return (
        <SimDetailsTitle route={Routes.productsSim} basePageTitle={t('products.sim.simProducts')} />
      );
    }

    if (location.pathname.includes(Routes.productsRsim) && euicc) {
      return <RSimInventoryDetailsTitle />;
    }

    if (location.pathname.includes(Routes.admin)) {
      return <TablePageTitle>{t('customFields.admin')}</TablePageTitle>;
    }

    if (location.pathname.includes(Routes.products)) {
      return <TablePageTitle>{t('common.products')}</TablePageTitle>;
    }

    if (location.pathname.includes(Routes.dashboard)) {
      return <TablePageTitle>{t('dashboard.title')}</TablePageTitle>;
    }

    return <TablePageTitle>{t('simProfiles.profiles')}</TablePageTitle>;
  };

  return (
    <Box>
      <NavigationAppBar title={title ?? getTitle()} />
    </Box>
  );
};
